const controller = 'HlaseniDojitelnostiKU';

/** Permission codes used by the milkability screens and actions. */
export const milkabilityPermissions = {
    updateTechnician: `${controller}/EditHlaseniTechnik`,
    updateLeaderTechnician: `${controller}/EditHlaseniVedouciTechnik`,
    updateAdmin: `${controller}/EditHlaseniAdmin`,
    listTechnician: `${controller}/SeznamHlaseniTechnik`,
    listLeaderTechnician: `${controller}/SeznamHlaseniVedouciTechnik`,
    listAdmin: `${controller}/SeznamHlaseniAdmin`,
};

const reproductionController = 'Reprodukce';

/** Legacy permission codes still used when linking from the reproduction area. */
export const legacyMilkabilityPermissions = {
    reportBatchList: `${reproductionController}/SeznamDavekHlaseni`,
};
